import React, { useRef, useEffect } from 'react';
import { Formik, Form, FieldArray, Field } from 'formik';
import * as Yup from 'yup';
import styles from './UpdateResearch.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import { useFetchDropDownTypes } from '../../../../Hooks/Settings';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import userIcon from '../../../../assets/Imagess/userinputicon.svg';
import emailIcon from '../../../../assets/Imagess/emaildropdownicon.svg';
import {
  useFetchOpportunityTypes,
  useFetchResearchById,
} from '../../../../Hooks/Research';
import moment from 'moment';
import 'react-quill/dist/quill.snow.css';
import Buttons from '../../../Atoms/Buttons/Buttons';

import he from 'he';
import TextEditor from '../../../Molecules/Email/TextEditor';
import DateInput from '../../../Atoms/Inputs/DateInput';

const UpdateResearch = () => {
  const { id } = useParams();
  const customizedToast = useToast();
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const { data, isLoading, refetch } = useFetchResearchById(id);
  const { data: areas } = useFetchDropDownTypes(14);
  const { data: departments } = useFetchDropDownTypes(15);
  const { data: types } = useFetchOpportunityTypes();

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      formikRef.current.setValues({
        nameAr: data.data.titleAR || '',
        sector: data.data.opportunityTypeId,
        investigatorAr: data.data.investigatorNameAR || '',
        email: data.data.email || '',
        department: data.data.departmentId || '',
        focusArea: data.data.focusAreaId || '',
        date: data.data.publicationDate
          ? new Date(data.data.publicationDate)
          : new Date(),
        contentAr: he.decode(data.data.descriptionAR || ''),
        authors: data.data.authors || [
          {
            researchAuthorsId: '00000000-0000-0000-0000-000000000000',
            authorNameAR: '',
          },
        ],
      });
    }
  }, [data]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('Arabic title is required'),
    sector: Yup.number().required('Sector is required'),
    investigatorAr: Yup.string().required(
      'Arabic Investigator name is required',
    ),
    email: Yup.string().required('Email is required'),
    department: Yup.string().required('Department is required'),
    focusArea: Yup.string().required('Focus Area is required'),
    date: Yup.date().required('Date is required'),
    contentAr: Yup.string().required('مطلوب تعبئته'),
    authors: Yup.array()
      .of(
        Yup.object().shape({
          authorNameAR: Yup.string().required('Author Name AR is required'),
        }),
      )
      .required('Authors are required'),
  });

  const updateResearch = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL + `/api/Research/ResearchOpportunities`,
        fields,
        {
          headers: securityHeaders,
        },
      );
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث البحث بنجاح' : 'تم إنشاء البحث بنجاح',
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    const formData = {
      opportunityTypeId: parseInt(values.sector, 10),
      investigatorNameAR: values.investigatorAr,
      contentAR: he.decode(values.contentAr),
      titleAR: values.nameAr,
      email: values.email,
      departmentId: values.department,
      focusAreaId: values.focusArea,
      publicationDate: moment(values.date).format('YYYY-MM-DD'),
      researchOpportunityId: id ? id : '00000000-0000-0000-0000-000000000000',
      ResearchAuthors: values.authors,
    };
    updateResearch.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }
  console.log('Vdsnvjkdsv', types);
  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تعديل البحث' : 'إضافة بحث جديد'}
          singleButton
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: data?.data?.titleAR || '',
            sector: data?.data?.opportunityTypeId,
            investigatorAr: data?.data?.investigatorNameAR || '',
            email: data?.data?.email || '',
            department: data?.data?.departmentId || '',
            focusArea: data?.data?.focusAreaId || '',
            date: data?.data?.publicationDate
              ? new Date(data?.data?.publicationDate)
              : new Date(),
            contentAr: data?.data?.descriptionAR || '',
            authors: data?.data?.authors || [
              {
                researchAuthorsId: '00000000-0000-0000-0000-000000000000',
                authorNameAR: '',
              },
            ],
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form className={styles['form-cont']}>
              <div className={styles['steps']}>
                <div className={`${styles['step-container']} ${styles['rtl']}`}>
                  <TextInput
                    label='الاسم'
                    placeholder='أدخل الاسم'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{
                      padding: '0px',
                      justifyContent: 'flex-start',
                    }}
                    name='nameAr'
                    value={values.nameAr}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                  />
                  <TextInput
                    label='المحقق الرئيسي'
                    placeholder='أدخل الاسم'
                    icon={userIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    name='investigatorAr'
                    value={values.investigatorAr}
                    errors={errors.investigatorAr}
                    touched={touched.investigatorAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                  />
                  <CustomSelect
                    label='القسم'
                    placeholder='اختر القسم'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    value={values.department}
                    onChange={(e) => setFieldValue('department', e.value)}
                    options={departments?.data?.map((option) => ({
                      value: option.value,
                      text: option.text_AR,
                    }))}
                    errors={errors.department && touched.department}
                    touched={errors.department && touched.department}
                    right
                  />
                  <div className={styles['step-row']}>
                    <div style={{ width: '50%' }}>
                      <CustomSelect
                        label='مجال التركيز'
                        placeholder='اختر المجال'
                        icon={folderIcon}
                        style={{ width: '100%' }}
                        value={values.focusArea}
                        onChange={(e) => setFieldValue('focusArea', e.value)}
                        options={areas?.data?.map((option) => ({
                          value: option.value,
                          text: option.text_AR,
                        }))}
                        errors={errors.focusArea && touched.focusArea}
                        touched={errors.focusArea && touched.focusArea}
                      />
                    </div>
                    <div style={{ width: '50%' }}>
                      <DateInput
                        label='التاريخ'
                        placeholder='اختر التاريخ'
                        showIcon
                        value={values.date}
                        name='date'
                        onChange={setFieldValue}
                        dateFormat='yyyy-MM-dd'
                        errors={errors.date}
                        touched={touched.date}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <CustomSelect
                    label='قطاع الأبحاث'
                    placeholder='اختر قطاع البحث'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    value={values.sector}
                    onChange={(e) => setFieldValue('sector', e.value)}
                    options={types?.data?.map((option) => ({
                      value: option.opportunityType,
                      text: option.opportunityTextAR,
                    }))}
                    errors={errors.sector && touched.sector}
                    touched={errors.sector && touched.sector}
                    right
                  />
                  <div
                    className={styles['step-container']}
                    style={{ marginTop: '20px' }}
                  >
                    <TextInput
                      label='البريد الإلكتروني'
                      placeholder='أدخل البريد الإلكتروني'
                      icon={emailIcon}
                      style={{
                        width: '100%',
                        justifyContent: 'flex-start',
                      }}
                      containerStyle={{ padding: '0px' }}
                      errors={errors.email}
                      touched={touched.email}
                      value={values.email}
                      name='email'
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <FieldArray name='authors'>
                {({ insert, remove, push }) => (
                  <div>
                    {values.authors?.length > 0 &&
                      values.authors.map((author, index) => (
                        <div key={index} className={styles['steps']}>
                          <div style={{ display: 'none' }}>
                            <TextInput
                              value={
                                isEmpty(author.researchAuthorsId)
                                  ? '00000000-0000-0000-0000-000000000000'
                                  : author.researchAuthorsId
                              }
                              errors={
                                errors.authors?.[index]?.researchAuthorsId
                              }
                              touched={
                                touched.authors?.[index]?.researchAuthorsId
                              }
                              name={`authors.${index}.researchAuthorsId`}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                              }}
                            />
                          </div>

                          <TextInput
                            label='اسم المؤلف بالعربية'
                            placeholder='أدخل الاسم'
                            name={`authors.${index}.authorNameAR`}
                            value={author.authorNameAR}
                            errors={errors.authors?.[index]?.authorNameAR}
                            touched={touched.authors?.[index]?.authorNameAR}
                            onChange={(name, value) =>
                              setFieldValue(name, value)
                            }
                          />
                        </div>
                      ))}

                    <Buttons
                      text='إضافة مؤلف'
                      rounded={true}
                      color='rgba(13, 160, 110, 1)'
                      handleOnClick={() =>
                        push({
                          researchAuthorsId:
                            '00000000-0000-0000-0000-000000000000',
                          authorNameEN: '',
                          authorNameAR: '',
                        })
                      }
                      style={{
                        fontFamily: 'BukraMedium',
                        marginTop: '26px',
                        width: 'auto',
                      }}
                    />
                  </div>
                )}
              </FieldArray>
              <div>
                <div
                  className={`${styles['quill-container']} ${styles['rtl']}`}
                >
                  <TextEditor
                    label='محتوى البحث'
                    value={values.contentAr}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    name='contentAr'
                    placeholder='ادخل المحتوى'
                    errors={errors.contentAr}
                    touched={touched.contentAr}
                    right
                  />
                </div>
              </div>
              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateResearch;
